module.exports = __webpack_public_path__ + "static/media/clearfilter.05af589c.svg";